import { Profile, SkillRotation } from '@/types/profile'
import { CSSProperties, useMemo } from 'react'
import { SkillPriorityComponent } from '../planner/skill-rotation/skill-priority'
import './SkillRoration.scss'

export function SkillRotationEmbed({
  planner,
  set,
  style
}: {
  planner: Profile
  set: string
  style: CSSProperties | undefined
}) {
  const skillRorations = useMemo(() => planner.skillRotations, [planner.skillRotations])
  const skillRotation: SkillRotation | undefined = useMemo(
    () => (skillRorations ?? []).find((variant, index) => variant.id === set || `${index}` === set),
    [skillRorations, set]
  )

  return skillRotation ? (
    <div className="poe-planner-skill-rotation-embed" style={style}>
      <SkillPriorityComponent title={skillRotation.name || ''} groups={skillRotation.groups} editMode={false} />
    </div>
  ) : null
}
